import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import { APPLICATION_CONTEXTS } from "../../constants";
import PatientBanner from "../common/patientBanner";
import NavigationBar from "../common/navigationBar";

class MealSlideshow extends Component {
  /**************
   * Properties *
   **************/
  NEXT = "next";
  PREVIOUS = "previous";
  state = {
    bannerVisible: {
      visible: false,
    },
    baseUrl: "/room_service/meal",
    navigationBar: {
      mainMenu: true,
      back: true,
      backRoute: "/room_service",
    },
    meals: {
      breakfast: [
        {
          id: "page1",
          bannerVisible: false,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Categories.png"),
          buttons: [
            {
              id: "1",
              className: "button-category-item-1",
              direction: this.NEXT,
            },
          ],
        },
        {
          id: "page2",
          bannerVisible: false,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Category1_Item1.png"),
          buttons: [
            { id: "1", className: "button-food-item-1", direction: this.NEXT },
          ],
        },
        {
          id: "page3",
          bannerVisible: false,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Category1_Item1_Quantity1.png"),
          buttons: [
            { id: "1", className: "button-food-item-1", direction: this.NEXT },
          ],
        },
        {
          id: "page4",
          bannerVisible: false,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Categories_Cat1_Quantity1.png"),
          buttons: [
            {
              id: "1",
              className: "button-category-item-2",
              direction: this.NEXT,
            },
          ],
        },
        {
          id: "page5",
          bannerVisible: false,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Categories_Cat2.png"),
          buttons: [
            {
              id: "1",
              className: "button-category-item-2",
              direction: this.NEXT,
            },
          ],
        },
        {
          id: "page6",
          bannerVisible: false,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Category2_Item1.png"),
          buttons: [
            { id: "1", className: "button-food-item-1", direction: this.NEXT },
          ],
        },
        {
          id: "page7",
          bannerVisible: false,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Category2_Item1_Quantity1.png"),
          buttons: [
            { id: "1", className: "button-view-my-meal", direction: this.NEXT },
          ],
        },
        {
          id: "page8",
          bannerVisible: false,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Category2_Quantity1_ViewMeal.png"),
          buttons: [
            { id: "1", className: "button-view-my-meal", direction: this.NEXT },
          ],
        },
        {
          id: "page9",
          bannerVisible: true,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Summary_Page1_Down.png"),
          buttons: [
            { id: "1", className: "button-page-down", direction: this.NEXT },
          ],
        },
        {
          id: "page10",
          bannerVisible: true,
          back: true,
          mainMenu: true,
          src: require("./images/RoomService_Meal1_Summary_Page2_Order.png"),
          buttons: [
            { id: "1", className: "button-page-up", direction: this.PREVIOUS },
            { id: "2", className: "button-order-meal", direction: this.NEXT },
          ],
        },
        {
          id: "page11",
          bannerVisible: true,
          back: false,
          mainMenu: false,
          src: require("./images/1277_RoomService_Meal1_DeliveryTimes1.png"),
          buttons: [
            {
              id: "1",
              className: "button-popup-back-to-cancel",
              direction: this.PREVIOUS,
            },
            {
              id: "2",
              className: "button-popup-select-to-order-meal",
              direction: this.NEXT,
            },
          ],
        },
        {
          id: "page12",
          bannerVisible: true,
          back: false,
          mainMenu: false,
          src: require("./images/1277_RoomService_Meal1_DeliveryTimes1_OrderSuccess.png"),
          buttons: [
            {
              id: "1",
              className: "button-popup-select-to-continue",
              direction: this.NEXT,
            },
          ],
        },
      ],
    },
  };

  getCurrentMeal = (props = this.props) => props.match.params.meal;

  getCurrentPage = (props = this.props) => {
    const meal = this.getCurrentMeal(props);
    const numPages = this.getCurrentMealNumPages(props);
    let page = this.getCurrentPageIndex(props);
    if (page <= 0) {
      page = 1;
    }
    if (page > numPages) {
      page = numPages;
    }
    if (this.state.meals[meal]) {
      return this.state.meals[meal][page - 1];
    }
    return null;
  };

  getCurrentPageIndex = (props = this.props) =>
    parseInt(props.match.params.page, 10);

  getNextPage = (props = this.props) => {
    const numPages = this.getCurrentMealNumPages(props);
    let page = this.getCurrentPageIndex(props);
    page++;
    if (page > numPages) {
      page = numPages;
    }
    return page;
  };

  getPreviousPage = (props = this.props) => {
    let page = this.getCurrentPageIndex(props);
    page--;
    if (page <= 0) {
      page = 1;
    }
    return page;
  };

  getCurrentMealNumPages = (props = this.props) => {
    const meal = this.getCurrentMeal(props);
    if (this.state.meals[meal]) {
      return this.state.meals[meal].length;
    }
    return 0;
  };

  handleGetNextPage = (props = this.props) =>
    this.props.history.push(
      `${this.state.baseUrl}/${this.getCurrentMeal(props)}/${this.getNextPage(
        props
      )}`
    );

  handleGetPreviousPage = (props = this.props) =>
    this.props.history.push(
      `${this.state.baseUrl}/${this.getCurrentMeal(
        props
      )}/${this.getPreviousPage(props)}`
    );

  handleSelect = (direction = this.NEXT) => {
    if (this.getCurrentPageIndex() < this.getCurrentMealNumPages()) {
      if (direction === this.PREVIOUS) {
        this.handleGetPreviousPage();
      } else {
        this.handleGetNextPage();
      }
    } else {
      this.props.history.push(`/room_service`);
    }
  };

  handleOnKeyUp = (event) => {
    switch (event.key) {
      case "Enter":
        if (this.props.context === APPLICATION_CONTEXTS.SERVICES) {
          this.handleSelect();
        }
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  componentWillReceiveProps(nextProps) {
    let backRoute = "/room_service";
    if (this.getCurrentPageIndex(nextProps) !== 1) {
      backRoute = `${this.state.baseUrl}/${this.getCurrentMeal(
        nextProps
      )}/${this.getPreviousPage(nextProps)}`;
    }
    const page = this.getCurrentPage(nextProps);
    this.setState({
      bannerVisible: Object.assign({}, this.state.bannerVisible, {
        visible: page.bannerVisible,
      }),
      navigationBar: Object.assign({}, this.state.navigationBar, {
        backRoute: backRoute,
        mainMenu: page.mainMenu,
        back: page.back,
      }),
    });
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const page = this.getCurrentPage();
    if (page === null) {
      this.props.history.push("/room_service");
      return null;
    }
    return (
      <div className="service-1277">
        <PatientBanner {...this.state.bannerVisible} />
        <img className="slideshow" src={page.src} alt="" />
        {page.buttons.map((button) => (
          <button
            key={button.id}
            className={`button-item ${button.className}`}
            onMouseUp={() => this.handleSelect(button.direction)}
          />
        ))}
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedMealSlideshow = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(MealSlideshow);

export default withRouter(ConnectedMealSlideshow);
